import * as API from "../index";
/**
 * 设备管理
 */
export default {
  getListDevice: params => {
    return API.POST(BASEURL + "/api/v1/camera/listDevice", params);
  },
  updateDevice: params => {
    return API.POST(BASEURL + "/api/v1/camera/updateDevice", params);
  },
  flushDevice: params => {
    return API.GET(BASEURL + "/api/v1/cameraIcc/flush", params);
  }
};



// WEBPACK FOOTER //
// ./src/api/api_asset/api_asset.js